/* Retail Fixtures Co – smart search (2-10-2026): header dropdown + results page.
   Index: /collections/all?view=rfc-index&page=N (250/page) + /collections?view=rfc-cols, cached in localStorage for 6 hours. */
(function () {
  'use strict';
  var KEY = 'rfc-sidx-v1', TTL = 6 * 3600 * 1000, RECENT = 'rfc-recent';
  var STOP = { the: 1, a: 1, an: 1, for: 1, with: 1, and: 1, of: 1, in: 1, to: 1, on: 1, mm: 1, cm: 1, m: 1, x: 1, by: 1, inch: 1 };
  var SYN = { shelf: ['shelving', 'shelves'], shelving: ['shelf', 'shelves'], shelves: ['shelf', 'shelving'], trolly: ['trolley'], gondala: ['gondola'], plastic: ['polyethylene', 'plastic'], post: ['bollard', 'post'] };

  /* ---------- text helpers ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/&/g, ' and ').replace(/×/g, ' x ')
      .replace(/(\d)\s*x\s*(\d)/g, '$1 x $2')
      .replace(/[“”"'’‘()\[\],/\\|+:;!?–—-]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function stem(w) {
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (w.length > 4 && /(sses|shes|ches|xes)$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function words(s) {
    var out = [];
    norm(s).split(' ').forEach(function (w) {
      w = w.replace(/\.+$/, '');
      if (!w || /\d/.test(w) || STOP[w] || w.length < 2) return;
      out.push(stem(w));
    });
    return out;
  }
  /* sizes in mm found in a string: 2.1m, 2100mm, 76mm, 30cm, 1000 x 1000 */
  function sizesIn(s) {
    var t = norm(s), out = [], m, re = /(\d+(?:\.\d+)?)\s*(mm|cm|m|metre|metres|meter|meters)?(?![\d.])/g;
    while ((m = re.exec(t))) {
      var n = parseFloat(m[1]), u = m[2] || '';
      if (isNaN(n)) continue;
      var mm;
      if (u === 'mm') mm = n;
      else if (u === 'cm') mm = n * 10;
      else if (u && u.charAt(0) === 'm') mm = n * 1000;
      else if (n < 10 && m[1].indexOf('.') > 0) mm = n * 1000; /* bare 2.1 → 2.1 m */
      else if (n >= 20) mm = n;
      else continue;
      out.push(Math.round(mm));
    }
    return out;
  }
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) {
      var rowMin = 1e9;
      for (j = 1; j <= b.length; j++) {
        var c = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
    }
    return d[a.length][b.length];
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function sizeLabel(mm) { return mm >= 1000 ? (mm / 1000) + 'm (' + mm + 'mm)' : mm + 'mm'; }

  /* ---------- index ---------- */
  var DB = null, loading = null;
  function prep(p, colT) {
    p.o = String(p.o || '').replace(/Default Title\|?/g, '');
    p.tw = words(p.t);
    p.yw = words(p.y);
    var cw = [];
    (p.c || []).forEach(function (h) { if (colT[h]) cw = cw.concat(words(colT[h][0])); });
    p.cw = cw;
    p.ow = words(p.o);
    p.all = {};
    p.tw.concat(p.yw, p.cw, p.ow).forEach(function (w) { p.all[w] = 1; });
    p.sz = sizesIn(p.t + ' ' + (p.o || '').replace(/\|/g, ' '));
    var t = p.t;
    var hm = t.match(/(\d(?:\.\d)?)\s?m(?:etre)?\s+(?:high|tall)/i) || t.match(/(\d{4})\s?mm\s+(?:high|tall)/i) || t.match(/^(\d\.\d)m\b/i);
    p.hgt = hm ? (parseFloat(hm[1]) < 10 ? Math.round(parseFloat(hm[1]) * 1000) : parseInt(hm[1], 10)) : 0;
    var bm = t.match(/(\d{3})\s?mm\s+base/i);
    p.base = bm ? parseInt(bm[1], 10) : 0;
    var chips = [];
    if (p.hgt) chips.push((p.hgt / 1000) + 'm high');
    if (p.base) chips.push(p.base + 'mm base shelf');
    var mat = t.match(/stainless steel|mild steel|galvanised|polyethylene|powder coated|wood effect|timber|chrome|acrylic|plastic|aluminium/i);
    if (mat && chips.length < 2) chips.push(mat[0].toLowerCase());
    if (!p.hgt) {
      var d = t.match(/(\d{2,4})\s?mm(?!\s+base)/i);
      if (d && chips.length < 2) chips.push(d[1] + 'mm');
    }
    p.chips = chips.slice(0, 2);
    return p;
  }
  function build(raw) {
    var colT = {}, vocab = {};
    (raw.cols || []).forEach(function (c) { colT[c[0]] = [c[1], c[2]]; });
    var items = raw.items.map(function (p) { return prep(p, colT); });
    items.forEach(function (p) { for (var w in p.all) vocab[w] = (vocab[w] || 0) + 1; });
    return { items: items, cols: colT, vocab: vocab, vlist: Object.keys(vocab) };
  }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function load() {
    if (DB) return Promise.resolve(DB);
    if (loading) return loading;
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (c && c.ts && Date.now() - c.ts < TTL && c.items && c.items.length) { DB = build(c); return Promise.resolve(DB); }
    } catch (e) {}
    var base = '/collections/all?view=rfc-index&page=';
    loading = Promise.all([getJSON('/collections?view=rfc-cols').catch(function () { return []; }), getJSON(base + 1)]).then(function (r) {
      var cols = r[0], first = r[1], jobs = [];
      for (var i = 2; i <= first.pages; i++) jobs.push(getJSON(base + i));
      return Promise.all(jobs).then(function (rest) {
        var items = first.p;
        rest.forEach(function (pg) { items = items.concat(pg.p); });
        var raw = { ts: Date.now(), items: items, cols: cols };
        try { localStorage.setItem(KEY, JSON.stringify(raw)); } catch (e) {}
        DB = build(raw);
        return DB;
      });
    });
    loading.catch(function () { loading = null; });
    return loading;
  }

  /* ---------- query parsing ---------- */
  function correct(w, db, isLast) {
    if (isLast && w.length >= 2) {
      for (var k = 0; k < db.vlist.length; k++) if (db.vlist[k].indexOf(w) === 0 && db.vlist[k] !== w) return { w: w, prefix: true };
    }
    if (db.vocab[w]) return { w: w };
    var syn = SYN[w];
    if (syn) for (var i = 0; i < syn.length; i++) if (db.vocab[stem(syn[i])]) return { w: stem(syn[i]), corrected: true };
    if (isLast && w.length >= 3) {
      for (var j = 0; j < db.vlist.length; j++) if (db.vlist[j].indexOf(w) === 0) return { w: w, prefix: true };
    }
    if (w.length < 4) return { w: w, miss: true };
    var max = w.length >= 7 ? 2 : 1, best = null, bd = 9, bc = 0;
    db.vlist.forEach(function (v) {
      if (Math.abs(v.length - w.length) > max) return;
      var d = lev(w, v, max);
      if (d <= max && (d < bd || (d === bd && db.vocab[v] > bc))) { best = v; bd = d; bc = db.vocab[v]; }
    });
    return best ? { w: best, corrected: true } : { w: w, miss: true };
  }
  function parse(q, db, opts) {
    opts = opts || {};
    var raw = norm(q).split(' ').filter(Boolean);
    var wordsOut = [], read = [];
    var sizes = sizesIn(q);
    raw.forEach(function (tok, i) {
      tok = tok.replace(/\.+$/, '');
      if (!tok || /\d/.test(tok) || STOP[tok] || tok.length < 2) return;
      var s = stem(tok);
      var r = opts.exact ? (db.vocab[s] ? { w: s } : { w: s, prefix: opts.live && i === raw.length - 1 }) : correct(s, db, opts.live && i === raw.length - 1);
      r.raw = tok;
      wordsOut.push(r);
    });
    var seen = {};
    sizes = sizes.filter(function (s) { if (seen[s]) return false; seen[s] = 1; return true; });
    wordsOut.forEach(function (r) { read.push(r.prefix ? r.raw + '…' : (r.corrected ? r.w : r.raw)); });
    return { words: wordsOut, sizes: sizes, read: read, corrected: wordsOut.some(function (r) { return r.corrected; }) };
  }
  function sizeHit(p, mm) {
    for (var i = 0; i < p.sz.length; i++) if (Math.abs(p.sz[i] - mm) <= Math.max(1, mm * 0.01)) return true;
    return false;
  }
  function score(p, qp, loose) {
    var sc = 0, hits = 0;
    for (var i = 0; i < qp.words.length; i++) {
      var r = qp.words[i], w = r.w, got = 0;
      if (r.prefix) {
        for (var k in p.all) if (k.indexOf(w) === 0) { got = p.tw.some(function (t) { return t.indexOf(w) === 0; }) ? 2 : 1; break; }
      } else if (p.all[w]) {
        got = p.tw.indexOf(w) >= 0 ? 3 : (p.yw.indexOf(w) >= 0 ? 2 : 1);
      }
      if (!got && !loose) return 0;
      sc += got; if (got) hits++;
    }
    for (var j = 0; j < qp.sizes.length; j++) {
      if (sizeHit(p, qp.sizes[j])) { sc += 2; hits++; } else if (!loose) return 0;
    }
    if (loose && !hits) return 0;
    if (qp.words.length && p.tw.join(' ').indexOf(qp.words.map(function (r) { return r.w; }).join(' ')) >= 0) sc += 2;
    return sc;
  }
  function search(q, db, opts) {
    var qp = parse(q, db, opts);
    if (!qp.words.length && !qp.sizes.length) return { qp: qp, list: [] };
    var list = [];
    db.items.forEach(function (p) { var s = score(p, qp); if (s) list.push({ p: p, s: s }); });
    list.sort(function (a, b) { return b.s - a.s || a.p.pr - b.p.pr; });
    return { qp: qp, list: list.map(function (x) { return x.p; }) };
  }
  function depts(list, db, n) {
    var cnt = {};
    list.forEach(function (p) { (p.c || []).forEach(function (h) { if (db.cols[h]) cnt[h] = (cnt[h] || 0) + 1; }); });
    return Object.keys(cnt).sort(function (a, b) { return cnt[b] - cnt[a] || db.cols[a][1] - db.cols[b][1]; }).slice(0, n || 4)
      .map(function (h) { return { h: h, t: db.cols[h][0], n: db.cols[h][1], m: cnt[h] }; });
  }
  function suggest(list, qp, n) {
    if (!qp.words.length) return [];
    var key = qp.words[qp.words.length - 1].w, cnt = {};
    list.slice(0, 80).forEach(function (p) {
      var tw = norm(p.t).split(' ');
      for (var i = 0; i < tw.length; i++) {
        var s = stem(tw[i]);
        if (s === key || (qp.words[qp.words.length - 1].prefix && s.indexOf(key) === 0)) {
          var prev = tw[i - 1], next = tw[i + 1], ph;
          if (prev && !/\d/.test(prev) && !STOP[prev] && prev.length > 2) ph = prev + ' ' + tw[i];
          else if (next && !/\d/.test(next) && !STOP[next] && next.length > 2) ph = tw[i] + ' ' + next;
          if (ph) { ph = ph.replace(/s$/, function (m) { return /ss$/.test(ph) ? m : ''; }); cnt[ph] = (cnt[ph] || 0) + 1; }
          break;
        }
      }
    });
    return Object.keys(cnt).sort(function (a, b) { return cnt[b] - cnt[a]; }).slice(0, n || 4);
  }
  function recent() { try { return JSON.parse(localStorage.getItem(RECENT) || '[]'); } catch (e) { return []; } }
  function addRecent(q) {
    q = String(q || '').trim(); if (!q) return;
    var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    r.unshift(q);
    try { localStorage.setItem(RECENT, JSON.stringify(r.slice(0, 5))); } catch (e) {}
  }
  function clearRecent() { try { localStorage.removeItem(RECENT); } catch (e) {} }

  window.RFCSearch = { load: load, search: search, parse: parse, depts: depts, suggest: suggest, esc: esc, money: money, sizeLabel: sizeLabel, recent: recent, addRecent: addRecent, clearRecent: clearRecent, score: score, words: words, stem: stem };

  var ICON_SEARCH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>';
  var ICON_CLOCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  /* ======================================================================
     Header dropdown
     ====================================================================== */
  function initDropdown(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.hasAttribute('data-rfc-sd-ready')) return;
    form.setAttribute('data-rfc-sd-ready', '');
    var cfg = {};
    try { cfg = JSON.parse(form.getAttribute('data-rfc-sd') || '{}'); } catch (e) {}
    var popular = cfg.popular || [], sizeEx = cfg.sizes || [], deps = cfg.depts || [], quoteUrl = cfg.quote || '/search?q=';
    var panel = document.createElement('div');
    panel.className = 'rfc-sd';
    panel.id = 'rfc-sd-' + Math.random().toString(36).slice(2, 7);
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Search suggestions');
    form.appendChild(panel);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', panel.id);
    var clearBtn = form.querySelector('[data-rfc-sd-clear]');
    var active = -1, timer = null, lastQ = null;

    function opts() { return Array.prototype.slice.call(panel.querySelectorAll('[data-opt]')); }
    function setActive(i) {
      var o = opts();
      o.forEach(function (el, k) { el.classList.toggle('is-active', k === i); el.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      active = i;
      if (o[i]) { input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' }); } else input.removeAttribute('aria-activedescendant');
    }
    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); form.classList.add('is-open'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); form.classList.remove('is-open'); active = -1; input.removeAttribute('aria-activedescendant'); }
    function idify() { opts().forEach(function (el, k) { el.id = panel.id + '-o' + k; el.setAttribute('role', 'option'); }); }
    function qUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product'; }

    function renderEmpty() {
      var rec = recent(), h = '<div class="rfc-sd__grid rfc-sd__grid--empty"><div class="rfc-sd__col">';
      if (rec.length) {
        h += '<div class="rfc-sd__hd"><span>Your recent searches</span><button type="button" class="rfc-sd__clr" data-rfc-sd-clr>Clear</button></div><ul class="rfc-sd__list">';
        rec.forEach(function (r) { h += '<li><a data-opt href="' + qUrl(r) + '" data-q="' + esc(r) + '">' + ICON_CLOCK + '<span>' + esc(r) + '</span></a></li>'; });
        h += '</ul>';
      }
      if (sizeEx.length) {
        h += '<div class="rfc-sd__hd"><span>Search by size</span></div><p class="rfc-sd__note">Type heights, depths or tube sizes — we read them as filters.</p><div class="rfc-sd__chips">';
        sizeEx.forEach(function (s) { h += '<a data-opt class="rfc-sd__chip rfc-sd__chip--size" href="' + qUrl(s) + '" data-q="' + esc(s) + '">' + esc(s) + '</a>'; });
        h += '</div>';
      }
      h += '</div><div class="rfc-sd__col">';
      if (popular.length) {
        h += '<div class="rfc-sd__hd"><span>Try searching</span></div><div class="rfc-sd__chips">';
        popular.forEach(function (s) { h += '<a data-opt class="rfc-sd__chip" href="' + qUrl(s) + '" data-q="' + esc(s) + '">' + esc(s) + '</a>'; });
        h += '</div>';
      }
      if (deps.length) {
        h += '<div class="rfc-sd__hd"><span>Jump to a department</span></div><div class="rfc-sd__deps">';
        deps.forEach(function (d) { h += '<a data-opt href="' + esc(d.u) + '"><b>' + esc(d.t) + '</b><small>' + d.n + ' products</small></a>'; });
        h += '</div>';
      }
      h += '</div></div>';
      panel.innerHTML = h;
      var clr = panel.querySelector('[data-rfc-sd-clr]');
      if (clr) clr.addEventListener('click', function (e) { e.preventDefault(); clearRecent(); renderEmpty(); input.focus(); });
      idify(); active = -1;
    }

    function renderQuery(q) {
      panel.innerHTML = '<p class="rfc-sd__load">Searching…</p>';
      load().then(function (db) {
        if (input.value.trim() !== q) return;
        var res = search(q, db, { live: true }), list = res.list, qp = res.qp;
        var h = '<div class="rfc-sd__top">';
        if (list.length) {
          h += 'Showing <b>' + esc(qp.read.join(' ').replace(/…/g, '') || q) + '</b>';
          if (qp.corrected) h += ' — you typed “' + esc(q) + '”';
        } else h += 'No exact matches for <b>“' + esc(q) + '”</b>';
        var chips = qp.words.map(function (r) { return '“' + esc(r.prefix ? r.raw + '…' : r.w) + '”'; }).concat(qp.sizes.map(function (s) { return esc(sizeLabel(s)); }));
        if (chips.length) h += '<span class="rfc-sd__dot" aria-hidden="true">·</span><span class="rfc-sd__read">We read this as ' + chips.map(function (c) { return '<em>' + c + '</em>'; }).join(' ') + '</span>';
        h += '</div><div class="rfc-sd__grid">';
        var sug = suggest(list, qp, 4), dp = depts(list, db, 4);
        h += '<div class="rfc-sd__col rfc-sd__col--side">';
        if (sug.length) {
          h += '<div class="rfc-sd__hd"><span>Suggestions</span></div><ul class="rfc-sd__list">';
          sug.forEach(function (s) { h += '<li><a data-opt href="' + qUrl(s) + '" data-q="' + esc(s) + '">' + ICON_SEARCH + '<span>' + esc(s) + '</span></a></li>'; });
          h += '</ul>';
        }
        if (dp.length) {
          h += '<div class="rfc-sd__hd"><span>Departments</span></div><ul class="rfc-sd__list rfc-sd__list--dep">';
          dp.forEach(function (d) { h += '<li><a data-opt href="/collections/' + esc(d.h) + '"><span>' + esc(d.t) + '</span><small>' + d.n + '</small></a></li>'; });
          h += '</ul>';
        }
        if (!sug.length && !dp.length) h += '<p class="rfc-sd__note">Try fewer words, or a size like 2.1m or 76mm.</p>';
        h += '</div><div class="rfc-sd__col rfc-sd__col--prod"><div class="rfc-sd__hd"><span>Products</span><small>' + list.length + ' matching</small></div>';
        if (list.length) {
          h += '<ul class="rfc-sd__prods">';
          list.slice(0, 5).forEach(function (p) {
            h += '<li><a data-opt href="/products/' + esc(p.h) + '"><span class="rfc-sd__img">' + (p.i ? '<img src="' + esc(p.i.replace(/width=\d+/, 'width=120')) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span><span class="rfc-sd__pt"><b>' + esc(p.t) + '</b>' + (p.chips.length ? '<small>' + esc(p.chips.join(' · ')) + '</small>' : '') + '</span><span class="rfc-sd__pp">' + (p.pv ? '<small>from</small>' : '') + '<b>' + money(p.pr) + '</b><small>inc VAT</small></span></a></li>';
          });
          h += '</ul>';
        } else h += '<p class="rfc-sd__none">Nothing listed under that yet — we can usually source it. <a href="' + esc(quoteUrl) + encodeURIComponent(q) + '#rfc-sq">Ask for a quote</a></p>';
        h += '</div></div><div class="rfc-sd__ft">';
        if (list.length) h += '<a data-opt class="rfc-sd__all" href="' + qUrl(q) + '">See all ' + list.length + ' results for “' + esc(q) + '”</a>';
        h += '<a class="rfc-sd__quote" href="' + esc(quoteUrl) + encodeURIComponent(q) + '&type=product#rfc-sq">Can’t see your size? Get a quote</a><span class="rfc-sd__keys" aria-hidden="true">↑ ↓ to move · Enter to search · Esc to close</span></div>';
        panel.innerHTML = h;
        idify(); setActive(-1);
      }).catch(function () { panel.innerHTML = '<p class="rfc-sd__load">Press Enter to search.</p>'; });
    }

    function update() {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = !input.value;
      if (q === lastQ && !panel.hidden) return;
      lastQ = q;
      if (!q) renderEmpty(); else renderQuery(q);
      open();
    }
    input.addEventListener('focus', function () { load().catch(function () {}); lastQ = null; update(); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(update, 120); });
    input.addEventListener('keydown', function (e) {
      var o = opts();
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) update(); setActive(Math.min(active + 1, o.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
      else if (e.key === 'Escape') { if (!panel.hidden) { e.preventDefault(); close(); } }
      else if (e.key === 'Enter' && active >= 0 && o[active]) {
        e.preventDefault();
        var q = o[active].getAttribute('data-q'); if (q) addRecent(q); else if (input.value.trim()) addRecent(input.value.trim());
        window.location.href = o[active].getAttribute('href');
      }
    });
    panel.addEventListener('mousedown', function (e) { if (e.target.closest('a,button')) e.preventDefault(); });
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-q]');
      if (a) addRecent(a.getAttribute('data-q'));
      else if (e.target.closest('a[data-opt]') && input.value.trim()) addRecent(input.value.trim());
      if (e.target.closest('a')) window.location.href = e.target.closest('a').getAttribute('href');
    });
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      addRecent(q);
    });
    if (clearBtn) {
      clearBtn.hidden = !input.value;
      clearBtn.addEventListener('click', function () { input.value = ''; input.focus(); lastQ = null; update(); });
    }
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 0); });
  }

  /* ======================================================================
     Results page
     ====================================================================== */
  function initResults(root) {
    var q0 = root.getAttribute('data-q') || '';
    var params = new URLSearchParams(location.search);
    var exact = params.get('exact') === '1';
    var out = root.querySelector('[data-rfc-srp-out]');
    var fb = root.querySelector('[data-rfc-srp-fallback]');
    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-cfg') || '{}'); } catch (e) {}
    var PAGE = 24;
    var st = { q: q0, dropSizes: {}, f: { type: {}, height: {}, base: {}, price: {} }, sort: 'best', shown: PAGE };
    var PRICE = [['u250', 'Under £250', 0, 25000], ['250-500', '£250 – £500', 25000, 50000], ['500', '£500 and over', 50000, 1e12]];

    function qUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product'; }
    function setQuoteField(q) { var f = root.querySelector('[data-rfc-sq-need]'); if (f && !f.dataset.edited) f.value = q; }
    function facetVal(p, k) {
      if (k === 'type') return p.y || '';
      if (k === 'height') return p.hgt ? String(p.hgt) : '';
      if (k === 'base') return p.base ? String(p.base) : '';
      if (k === 'price') { for (var i = 0; i < PRICE.length; i++) if (p.pr >= PRICE[i][2] && p.pr < PRICE[i][3]) return PRICE[i][0]; }
      return '';
    }
    function facetLabel(k, v) {
      if (k === 'height') return (v / 1000) + 'm (' + v + 'mm)';
      if (k === 'base') return v + 'mm';
      if (k === 'price') { for (var i = 0; i < PRICE.length; i++) if (PRICE[i][0] === v) return PRICE[i][1]; }
      return v;
    }
    var FN = { type: 'Type', height: 'Height', base: 'Base shelf depth', price: 'Price' };

    function run(db) {
      var qEff = st.q;
      var res = search(qEff, db, { exact: exact });
      var qp = res.qp;
      var list = res.list;
      /* sizes the customer removed are dropped from the match */
      if (Object.keys(st.dropSizes).length) {
        var qp2 = { words: qp.words, sizes: qp.sizes.filter(function (s) { return !st.dropSizes[s]; }), read: qp.read };
        list = [];
        if (qp2.words.length || qp2.sizes.length) db.items.forEach(function (p) { var s = score(p, qp2); if (s) list.push({ p: p, s: s }); });
        list.sort(function (a, b) { return b.s - a.s || a.p.pr - b.p.pr; });
        list = list.map(function (x) { return x.p; });
        qp = qp2;
      }
      if (fb) fb.hidden = true;
      if (!list.length) return renderNone(db, qp);
      /* facets */
      var facets = {};
      ['type', 'height', 'base', 'price'].forEach(function (k) {
        var c = {};
        list.forEach(function (p) {
          var ok = ['type', 'height', 'base', 'price'].every(function (o) { if (o === k) return true; var sel = st.f[o]; return !Object.keys(sel).length || sel[facetVal(p, o)]; });
          if (!ok) return;
          var v = facetVal(p, k); if (v) c[v] = (c[v] || 0) + 1;
        });
        var keys = Object.keys(c);
        if (k === 'height' || k === 'base') keys.sort(function (a, b) { return a - b; });
        else if (k === 'price') keys.sort(function (a, b) { return PRICE.map(function (x) { return x[0]; }).indexOf(a) - PRICE.map(function (x) { return x[0]; }).indexOf(b); });
        else keys.sort(function (a, b) { return c[b] - c[a] || (a < b ? -1 : 1); });
        Object.keys(st.f[k]).forEach(function (v) { if (keys.indexOf(v) < 0) { keys.push(v); c[v] = 0; } });
        if (keys.length > 1 || Object.keys(st.f[k]).length) facets[k] = keys.map(function (v) { return { v: v, n: c[v] }; });
      });
      var filtered = list.filter(function (p) {
        return ['type', 'height', 'base', 'price'].every(function (o) { var sel = st.f[o]; return !Object.keys(sel).length || sel[facetVal(p, o)]; });
      });
      if (st.sort === 'low') filtered = filtered.slice().sort(function (a, b) { return a.pr - b.pr; });
      else if (st.sort === 'high') filtered = filtered.slice().sort(function (a, b) { return b.pr - a.pr; });
      else if (st.sort === 'az') filtered = filtered.slice().sort(function (a, b) { return a.t.localeCompare(b.t); });
      var dp = depts(list, db, 3);

      var h = '<h1 class="rfc-srp__h1">' + filtered.length + ' product' + (filtered.length === 1 ? '' : 's') + ' for “' + esc(st.q) + '”</h1>';
      if (qp.corrected && !exact) h += '<p class="rfc-srp__fix">Showing results for <b>' + esc(qp.read.join(' ')) + '</b>. <a href="/search?q=' + encodeURIComponent(st.q) + '&type=product&exact=1">Search for “' + esc(st.q) + '” instead</a></p>';
      var applied = [];
      parse(st.q, db, { exact: exact }).sizes.forEach(function (s) { if (!st.dropSizes[s]) applied.push('<button type="button" class="rfc-srp__chip" data-drop-size="' + s + '">Size: ' + esc(sizeLabel(s)) + ' <span aria-hidden="true">×</span><span class="rfc-srp-only"> remove</span></button>'); });
      ['type', 'height', 'base', 'price'].forEach(function (k) { Object.keys(st.f[k]).forEach(function (v) { applied.push('<button type="button" class="rfc-srp__chip" data-unf="' + k + '" data-v="' + esc(v) + '">' + FN[k] + ': ' + esc(facetLabel(k, v)) + ' <span aria-hidden="true">×</span><span class="rfc-srp-only"> remove</span></button>'); }); });
      if (applied.length) h += '<div class="rfc-srp__row"><span class="rfc-srp__lbl">Filters applied</span>' + applied.join('') + (applied.length > 1 ? '<button type="button" class="rfc-srp__clear" data-clear-all>Clear all</button>' : '') + '</div>';
      if (dp.length) {
        h += '<div class="rfc-srp__row"><span class="rfc-srp__lbl">Browse the full department</span>';
        dp.forEach(function (d) { h += '<a class="rfc-srp__dep" href="/collections/' + esc(d.h) + '">' + esc(d.t) + ' <small>' + d.n + '</small> <span aria-hidden="true">→</span></a>'; });
        h += '</div>';
      }
      h += '<div class="rfc-srp__body">';
      var fk = Object.keys(facets);
      if (fk.length) {
        h += '<details class="rfc-srp__facets" ' + (window.matchMedia('(min-width: 990px)').matches ? 'open' : '') + '><summary>Filter results</summary><div>';
        fk.forEach(function (k) {
          h += '<fieldset class="rfc-srp__fs"><legend>' + FN[k] + '</legend>';
          facets[k].forEach(function (o) {
            var id = 'rfc-f-' + k + '-' + String(o.v).replace(/[^a-z0-9]/gi, '');
            h += '<label for="' + id + '"><input type="checkbox" id="' + id + '" data-f="' + k + '" value="' + esc(o.v) + '"' + (st.f[k][o.v] ? ' checked' : '') + '><span>' + esc(facetLabel(k, o.v)) + '</span><small>' + o.n + '</small></label>';
          });
          h += '</fieldset>';
        });
        h += '</div></details>';
      }
      h += '<div class="rfc-srp__main"><div class="rfc-srp__bar"><p role="status">Showing <b>' + Math.min(st.shown, filtered.length) + '</b> of ' + filtered.length + '</p><label class="rfc-srp__sort">Sort by <select data-sort><option value="best">Best match</option><option value="low">Price, low to high</option><option value="high">Price, high to low</option><option value="az">Name, A–Z</option></select></label></div>';
      if (!filtered.length) h += '<p class="rfc-srp__empty">No products match those filters. <button type="button" class="rfc-srp__clear" data-clear-all>Clear filters</button></p>';
      h += '<ul class="rfc-srp__grid">';
      filtered.slice(0, st.shown).forEach(function (p) {
        h += '<li class="rfc-srp__card"><a class="rfc-srp__img" href="/products/' + esc(p.h) + '" tabindex="-1" aria-hidden="true">' + (p.y ? '<span class="rfc-srp__badge">' + esc(p.y) + '</span>' : '') + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="360" height="360">' : '') + '</a>' +
          '<div class="rfc-srp__cb"><h2><a href="/products/' + esc(p.h) + '">' + esc(p.t) + '</a></h2>' +
          (p.chips.length ? '<p class="rfc-srp__spec">' + p.chips.map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('') + '</p>' : '') +
          '<div class="rfc-srp__ft"><p class="rfc-srp__price">' + (p.pv ? '<small>From</small>' : '') + '<b>' + money(p.pr) + '</b><small>inc VAT</small></p><a class="rfc-btn rfc-btn--dark rfc-btn--sm" href="/products/' + esc(p.h) + '">' + (p.n > 1 ? 'Choose size' : 'View product') + '<span class="rfc-srp-only">: ' + esc(p.t) + '</span></a></div></div></li>';
      });
      h += '</ul>';
      if (filtered.length > st.shown) h += '<div class="rfc-srp__more"><button type="button" class="rfc-btn rfc-btn--line" data-more>Show more products</button></div>';
      h += '</div></div>';
      out.innerHTML = h;
      var sel = out.querySelector('[data-sort]'); if (sel) sel.value = st.sort;
      document.title = filtered.length + ' products for “' + st.q + '” | ' + (cfg.shop || document.title);
    }

    function renderNone(db, qp) {
      /* closest departments: collections whose names share a word, else the biggest departments */
      var ws = qp.words.map(function (r) { return r.w; }), loose = [];
      db.items.forEach(function (p) { var s = score(p, qp, true); if (s) loose.push(p); });
      var dp = depts(loose, db, 4);
      if (!dp.length) dp = (cfg.fallbackDepts || []).map(function (d) { return { h: d.h, t: d.t, n: d.n }; });
      var h = '<div class="rfc-srp__none"><h1 class="rfc-srp__h1">We don’t list “' + esc(st.q) + '” yet — but we can probably get it</h1><p>' + esc(cfg.noneText || 'Our team sources shop fittings to order. Send the size and quantity below and we’ll come back with a written quote.') + '</p>';
      if (dp.length) { h += '<div class="rfc-srp__row"><span class="rfc-srp__lbl">Closest departments</span>'; dp.forEach(function (d) { h += '<a class="rfc-srp__dep rfc-srp__dep--soft" href="/collections/' + esc(d.h) + '">' + esc(d.t) + ' <small>(' + d.n + ')</small></a>'; }); h += '</div>'; }
      if ((cfg.popular || []).length) { h += '<div class="rfc-srp__row"><span class="rfc-srp__lbl">Or try</span>'; cfg.popular.forEach(function (s) { h += '<a class="rfc-srp__try" href="' + qUrl(s) + '">' + esc(s) + '</a>'; }); h += '</div>'; }
      h += '</div>';
      out.innerHTML = h;
      if (fb) fb.hidden = true;
      void ws;
    }

    out.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-f]')) { var k = t.getAttribute('data-f'); if (t.checked) st.f[k][t.value] = 1; else delete st.f[k][t.value]; st.shown = PAGE; rerender(t.id); }
      else if (t.matches('[data-sort]')) { st.sort = t.value; rerender(); }
    });
    out.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-drop-size')) { st.dropSizes[b.getAttribute('data-drop-size')] = 1; st.shown = PAGE; rerender(); }
      else if (b.hasAttribute('data-unf')) { delete st.f[b.getAttribute('data-unf')][b.getAttribute('data-v')]; rerender(); }
      else if (b.hasAttribute('data-clear-all')) { st.f = { type: {}, height: {}, base: {}, price: {} }; st.dropSizes = {}; rerender(); }
      else if (b.hasAttribute('data-more')) { st.shown += PAGE; rerender(null, true); }
    });
    var DBR = null;
    function rerender(focusId, keepScroll) {
      var y = window.scrollY;
      run(DBR);
      if (focusId) { var el = document.getElementById(focusId); if (el) el.focus(); }
      if (keepScroll) window.scrollTo(0, y);
    }
    var qf = root.querySelector('[data-rfc-sq-need]');
    if (qf) qf.addEventListener('input', function () { qf.dataset.edited = '1'; });
    setQuoteField(q0);
    if (!q0) return;
    addRecent(q0);
    out.innerHTML = '<p class="rfc-srp__loading" role="status">Finding products for “' + esc(q0) + '”…</p>';
    load().then(function (db) { DBR = db; run(db); }).catch(function () { out.innerHTML = ''; if (fb) fb.hidden = false; });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('form[data-rfc-sd]'), initDropdown);
    var r = document.querySelector('[data-rfc-srp]');
    if (r) initResults(r);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
